import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	TextField,
} from '@mui/material';
import React, {
	ChangeEvent,
	FC,
	FunctionComponent,
	useCallback,
	useEffect,
	useState,
} from 'react';
import { useTranslation } from '../../services';

interface ButtonWithNotesInteface {
	WrappedComponent: FunctionComponent<any>;
	callback: (value: boolean, notes: string) => void;
	propsWrapped: {
		title: string;
		color?:
			| 'inherit'
			| 'default'
			| 'primary'
			| 'secondary'
			| 'error'
			| 'info'
			| 'success'
			| 'warning'
			| undefined;
	};
}

const ButtonWithNotes: FC<ButtonWithNotesInteface> = ({
	callback,
	WrappedComponent,
	propsWrapped,
}) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const [notes, setNotes] = useState('');
	const [error, setError] = useState<boolean>(false);
	const handleNotesChange = useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			const val = e.target.value;
			setNotes(val);
		},
		[setNotes]
	);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = useCallback(
		(val: boolean) => {
			if (!error) {
				callback(val, notes);
				setOpen(false);
				setNotes('');
			} else if (!val) {
				callback(val, notes);
				setOpen(false);
				setNotes('');
			}
		},
		[callback, notes, error]
	);

	useEffect(() => {
		if (notes === '') {
			setError(true);
		} else {
			setError(false);
		}
	}, [notes]);

	return (
		<>
			<IconButton onClick={handleClickOpen} {...propsWrapped}>
				<WrappedComponent />
			</IconButton>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>{propsWrapped.title}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{t('Please describe the reason.')}
					</DialogContentText>
					<TextField
						required
						autoFocus
						margin="dense"
						onChange={handleNotesChange}
						id="notes"
						value={notes}
						label={t('Reason')}
						type="text"
						fullWidth
						error={error}
						helperText={error && t('"Reason" is a required field')}
						multiline
						variant="standard"
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => handleClose(false)}>{t('No')}</Button>
					<Button onClick={() => handleClose(true)}>{t('Yes')}</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default ButtonWithNotes;
